import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs-compat/Observable';
import { environment } from 'environments/environment';
import { PharmacyDetailsModel } from 'app/shared/models/pharmacy';

@Injectable()
export class PharmacyUserService {

    constructor(private _http: HttpClient) { }

    get = (): Observable<PharmacyDetailsModel[]> => {
        return this._http.get<PharmacyDetailsModel[]>(`${environment.queryModel}PharmacyUser/GetPharmacyUsers`);
    }

    getPharmacyUserStaff = (pharmacyId: number): Observable<any[]> => {
        return this._http.get<any[]>(`${environment.queryModel}PharmacyUser/PharmacyUserStaff?pharmacyId=${pharmacyId}`);
    }
}